"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevengeAbilityHandler = exports.RevengeActorAbilityFactory = exports.RevengeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const Registries_1 = require("../../core/state/Registries");
class RevengeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Revenge;
        this.__typeName = "Revenge";
    }
}
exports.RevengeAbilityArgs = RevengeAbilityArgs;
let RevengeActorAbilityFactory = class RevengeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Revenge", "Self", 0);
    }
};
RevengeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Revenge")
], RevengeActorAbilityFactory);
exports.RevengeActorAbilityFactory = RevengeActorAbilityFactory;
let RevengeAbilityHandler = class RevengeAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            creatorId: actorId,
            targetId: actorId,
            effect: new core_1.EffectOnHitEffectArgs("Revenge", "Lowers resistance on hit", 100, new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.AllDamageResistance, 25), Duration_1.Duration.Permanent),
            duration: Duration_1.Duration.Permanent,
            supernatural: true,
            sequence: sequence.pushSequence("sequential"),
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
RevengeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Revenge)
], RevengeAbilityHandler);
exports.RevengeAbilityHandler = RevengeAbilityHandler;
